import { useQuery } from '@tanstack/react-query'
import type { UseAppQueryOptions } from 'libs/data-access/queries/src/lib/types'

import {
  fetchMembershipNotifications,
  type FetchMembershipNotificationsOptions
} from '../membership.notifications.api'
import { membershipNotificationsQueryKeys } from '../membership.notifications.cacheKeys'
import type { MembershipNotificationsSchema } from '../types/membership.notifications.schema'

export const useFetchNotifications = (
  request?: FetchMembershipNotificationsOptions,
  queryOptions?: UseAppQueryOptions<MembershipNotificationsSchema>
) =>
  useQuery({
    ...queryOptions,
    queryKey: membershipNotificationsQueryKeys.notifications(),
    queryFn: () => fetchMembershipNotifications(request)
  })
